<div class="user-info" role="dialog" aria-labelledby="user-info-title" aria-modal="true" aria-label="Brugerinformationspanel">
    <div class="user-info__header">
        <h2 class="user-info__title" id="user-info-title">Brugerinfo</h2>
        <button class="user-info__close" (click)="onClose()" aria-label="Luk brugerinformationspanel" type="button" title="Luk">
            <span aria-hidden="true">✕</span>
        </button>
    </div>

    @if (data) {
    <div class="user-info__body">
        <section class="user-info__section" aria-labelledby="person-heading">
            <h3 class="user-info__section-title" id="person-heading">Person</h3>
            <!-- axe-linter-disable-next-line -->
            <dl class="user-info__list">
                @if (data.user.initialer) {
                    <dt class="user-info__label">Initialer:</dt>
                    <dd class="user-info__value">{{ data.user.initialer }}</dd>
                }
                <dt class="user-info__label">Navn:</dt>
                <dd class="user-info__value">{{ data.user.name }}</dd>

                @if(data.user.email) {
                <dt class="user-info__label">Email:</dt>
                <dd class="user-info__value">
                    <a [href]="'mailto:' + data.user.email" class="user-info__link" [attr.aria-label]="'Send email til ' + data.user.email"> {{ data.user.email }} </a>
                </dd>
                }
            </dl>
            @if(data.user.phone) {
            <dl class="user-info__list">
                <dt class="user-info__label">Telefon:</dt>
                <dd class="user-info__value">
                    <a [href]="'tel:' + data.user.phone" class="user-info__link" [attr.aria-label]="'Ring til ' + data.user.phone"> {{ data.user.phone }} </a>
                </dd>
            </dl>
            }
        </section>

        <section class="user-info__section" aria-labelledby="works-heading">
            <h3 class="user-info__section-title" id="works-heading">Værk</h3>
            <dl class="user-info__list">
                @if(data.works.name) {
                <ng-container>
                    <dt class="user-info__label">Navn:</dt>
                    <dd class="user-info__value">{{ data.works.name }}</dd>
                </ng-container>
                } @if(data.works.address) {

                <dt class="user-info__label">Addresse:</dt>
                <dd class="user-info__value">{{ data.works.address }}</dd>
                } @if(data.works.phone) {

                <dt class="user-info__label">Telefon:</dt>
                <dd class="user-info__value">
                    <a [href]="'tel:' + data.works.phone" class="user-info__link" [attr.aria-label]="'Ring til værk: ' + data.works.phone"> {{ data.works.phone }} </a>
                </dd>
                }
            </dl>
        </section>
    </div>
    }
</div>
